import { lazy } from 'react';
import PageLoadBoundary from '@/components/PageLoadBoundary';
import Login from "@/pages/Login";
import { Navigate, createBrowserRouter } from "react-router-dom";
import { AuthRoute } from "@/components/AuthRouter";

const MainPage = lazy(() => import('@/pages/Main'));
const Register = lazy(() => import('@/pages/Register'));
const ForgotPassword = lazy(() => import('@/pages/ForgotPassword'));
const ProjectDetail = lazy(() => import('@/components/SubPage/ProjectDetail'));
const PurchaseInboundDetail = lazy(() => import('@/components/SubPage/InventoryManagement/PurchaseInboundDetail'));

// 配置路由实例
const router = createBrowserRouter([
    {
        path: "/",
        element: (
            <AuthRoute>
                <PageLoadBoundary><MainPage /></PageLoadBoundary>
            </AuthRoute>
        ),
        children: [
            {
                path: "project-management",
                element: <Navigate to="/?menu=2-1" replace />
            },
            {
                path: "project-detail/:id",
                element: <PageLoadBoundary><ProjectDetail /></PageLoadBoundary>
            },
            {
                path: "purchase-inbound-detail/:id",
                element: <PageLoadBoundary><PurchaseInboundDetail /></PageLoadBoundary>
            }
            // ... 其他子路由
        ]
    },
    {
        path: "/login",
        element: <Login />
    },
    {
        path: "/register",
        element: <PageLoadBoundary><Register /></PageLoadBoundary>
    },
    {
        path: "/forgot-password",
        element: <PageLoadBoundary><ForgotPassword /></PageLoadBoundary>
    },
    {
        path: "/reset-password",
        element: <PageLoadBoundary><ForgotPassword /></PageLoadBoundary>
    },
    {
        path: "/Login",
        element: <Navigate to="/login" replace />
    },
    {
        path: "/Register",
        element: <Navigate to="/register" replace />
    },
    {
        path: "/ForgotPassword",
        element: <Navigate to="/forgot-password" replace />
    },
    {
        path: "/ResetPassword",
        element: <Navigate to="/reset-password" replace />
    }
]);

export default router;
